import {Component, Input, OnInit} from '@angular/core';
import {PickupPointFee} from "../../edit/pickup-point.fee";
import * as _ from "lodash";
import {SessionService} from "../../../../core/session.service";

@Component({
    selector: 'pickup-point-fee-card-content',
    templateUrl: './pickup-point-fee-card-content.component.html',
    providers: []
})
export class PickupPointFeeCardContentComponent implements OnInit {

    @Input() model:PickupPointFee;
    @Input() pupMap:any;

    isCollapsed:boolean;
    constructor(private session:SessionService) {
    }

    getCurrencyCode(){
        if(!!this.session.getUserSession()){
            return this.session.getUserSession().currencyCode;
        }
    }

    getPickupNames(){
        let context = this;
        return _.map(this.model.pickupPointOids, function(id){ return context.pupMap[id]; }).join(', ');
    }

    ngOnInit() {
        this.isCollapsed=true;
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/pickuppointfee/list/fee-card-content/pickup-point-fee-card-content.component.ts